import React, { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import SearchImg from "../../../Assets/AppComponent/Arrow/Layer_1@2x.png";
import _ from "lodash";
import { ShimmerTable } from "react-shimmer-effects";
import {
  settheAdvanceEmployeeDatas_summaryHold,
  settheAdvanceEmployeeDatas_summary_particularHold,
} from "../../../Redux/Slice";

export const Attendance_summarycounts = (props) => {
  const {
    setdtPageindex,
    dtpageindex,

    range,
    datas,
    datefilter,
    filterForWhite,
    client,
  } = props;

  const state = useSelector((state) => state);

  const dashboardData =
    state.SideBarFiles.UserEmailID == "hdfcsales@uds.in" ||
    state.SideBarFiles.UserEmailID == "arcolab@uds.in" ||
    state.SideBarFiles.UserEmailID == "sbilife@uds.in"
      ? state.EmployeeOfAdvanceAttendanceParticular_summaryRecordsCall
          .EmployeeOfAdvanceAttendanceRecordsDataparticular_summary
      : state.EmployeeOfAdvanceAttendance_summaryRecordsCall
          .EmployeeOfAdvanceAttendanceRecordsData_summary;
  // const dashboardData = useSelector((state) => state.EmployeeOfAdvanceAttendance_summaryRecordsCall.EmployeeOfAdvanceAttendanceRecordsData_summary);
  const [goPage, setGoPage] = useState(1);
  // const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [sno, setsno] = useState(0);
  const [employeesearch, setempsearch] = useState("");

  useEffect(() => {
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      if (
        state.SideBarFiles.UserEmailID != "hdfcsales@uds.in" &&
        state.SideBarFiles.UserEmailID != "sbilife@uds.in" &&
        state.SideBarFiles.UserEmailID != "arcolab@uds.in"
      ) {
        const payload = {
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
          from_date: range[0],
          to_date: range[1],
          range: datefilter.range,
          page: dtpageindex,
          page_size: "10",
          search: employeesearch,
          client: client,
        };
        dispatch(settheAdvanceEmployeeDatas_summaryHold(payload));
      } else {
        const payload_hd = {
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
          from_date: range[0],
          to_date: range[1],
          range: datefilter.range,
          page: dtpageindex,
          page_size: "10",
          search: employeesearch,
          client_type:
            state.SideBarFiles.UserEmailID == "hdfcsales@uds.in"
              ? "HDFC Sales"
              : state.SideBarFiles.UserEmailID == "sbilife@uds.in"
                ? "SBI life"
                : state.SideBarFiles.UserEmailID == "arcolab@uds.in" &&
                  "STRIDES",
          client: client,
        };
        dispatch(settheAdvanceEmployeeDatas_summary_particularHold(payload_hd));
      }
    }
  }, [range, datas, employeesearch, client]);

  const tableHeaderStyle = {
    padding: "10px",
    fontWeight: "500",
    background: "#f79c37",
    // position: "sticky",
    // top: 0,
    color: "#fff",
    // zIndex: 2
  };

  const tableHeaderStyleFirst = {
    padding: "10px",
    fontWeight: "500",
    background: "#f79c37",
    // position: "sticky",
    // top: 0,
    color: "#fff",
    // zIndex: 2,
    borderRadius: "10px 0px 0px 10px",
  };

  const tableHeaderStyleLast = {
    padding: "10px",
    fontWeight: "500",
    background: "#f79c37",
    // position: "sticky",
    // top: 0,
    color: "#fff",
    // zIndex: 2,
    borderRadius: "0px 10px 10px 0px",
  };

  const tableCellStyle = {
    padding: "10px",
    borderBottom: "1px solid #ccc",
    fontSize: "12px",
    textAlign: "left",
  };
  const tableCellStyleno = {
    padding: "10px",
    borderBottom: "1px solid #ccc",
    fontSize: "12px",
    textAlign: "center",
  };
  const handleNext = (next) => {
    setdtPageindex(next + 1);
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      if (
        state.SideBarFiles.UserEmailID != "hdfcsales@uds.in" &&
        state.SideBarFiles.UserEmailID != "sbilife@uds.in" &&
        state.SideBarFiles.UserEmailID != "arcolab@uds.in"
      ) {
        const payload = {
          state: datas.state,
          region: datas.region,
          // zone: datas.zone,
          from_date: range[0],
          to_date: range[1],
          range: datefilter.range,
          // white_collar: filterForWhite.white_collar,
          page: next + 1,
          page_size: "10",
          search: employeesearch,
          client: client,
        };
        dispatch(settheAdvanceEmployeeDatas_summaryHold(payload));
      } else {
        const payload_hd = {
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
          from_date: range[0],
          to_date: range[1],
          range: datefilter.range,
          // white_collar: filterForWhite.white_collar,
          page: next + 1,
          page_size: "10",
          search: employeesearch,
          client_type:
            state.SideBarFiles.UserEmailID == "hdfcsales@uds.in"
              ? "HDFC Sales"
              : state.SideBarFiles.UserEmailID == "sbilife@uds.in"
                ? "SBI life"
                : state.SideBarFiles.UserEmailID == "arcolab@uds.in" &&
                  "STRIDES",
        };
        dispatch(settheAdvanceEmployeeDatas_summary_particularHold(payload_hd));
      }
    }
  };

  const GotoEnteredPage = (gotopage) => {
    setdtPageindex(gotopage);
    if (range.length > 0 && !range.includes("NaN-aN-aN")) {
      if (
        state.SideBarFiles.UserEmailID != "hdfcsales@uds.in" &&
        state.SideBarFiles.UserEmailID != "sbilife@uds.in" &&
        state.SideBarFiles.UserEmailID != "arcolab@uds.in"
      ) {
        const payload = {
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
          from_date: range[0],
          to_date: range[1],
          range: datefilter.range,
          // white_collar: filterForWhite.white_collar,
          page: gotopage,
          page_size: "10",
          search: employeesearch,
          client: client,
        };
        dispatch(settheAdvanceEmployeeDatas_summaryHold(payload));
      } else {
        const payload_hd = {
          state: datas.state,
          region: datas.region,
          zone: datas.zone,
          from_date: range[0],
          to_date: range[1],
          range: datefilter.range,
          // white_collar: filterForWhite.white_collar,
          page: gotopage,
          page_size: "10",
          search: employeesearch,
          client_type:
            state.SideBarFiles.UserEmailID == "hdfcsales@uds.in"
              ? "HDFC Sales"
              : state.SideBarFiles.UserEmailID == "sbilife@uds.in"
                ? "SBI life"
                : state.SideBarFiles.UserEmailID == "arcolab@uds.in" &&
                  "STRIDES",
        };
        dispatch(settheAdvanceEmployeeDatas_summary_particularHold(payload_hd));
      }
    }
  };

  const handlePrevious = (previous) => {
    if (previous != 0) {
      setdtPageindex(previous);
      if (range.length > 0 && !range.includes("NaN-aN-aN")) {
        if (
          state.SideBarFiles.UserEmailID != "hdfcsales@uds.in" &&
          state.SideBarFiles.UserEmailID != "sbilife@uds.in" &&
          state.SideBarFiles.UserEmailID != "arcolab@uds.in"
        ) {
          const payload = {
            state: datas.state,
            region: datas.region,
            zone: datas.zone,
            from_date: range[0],
            to_date: range[1],
            range: datefilter.range,
            // white_collar: filterForWhite.white_collar,
            page: previous,
            page_size: "10",
            search: employeesearch,
            client: client,
          };
          dispatch(settheAdvanceEmployeeDatas_summaryHold(payload));
        } else {
          const payload_hd = {
            state: datas.state,
            region: datas.region,
            zone: datas.zone,
            from_date: range[0],
            to_date: range[1],
            range: datefilter.range,
            // white_collar: filterForWhite.white_collar,
            page: previous,
            page_size: "10",
            search: employeesearch,
            client_type:
              state.SideBarFiles.UserEmailID == "hdfcsales@uds.in"
                ? "HDFC Sales"
                : state.SideBarFiles.UserEmailID == "sbilife@uds.in"
                  ? "SBI life"
                  : state.SideBarFiles.UserEmailID == "arcolab@uds.in" &&
                    "STRIDES",
          };
          dispatch(
            settheAdvanceEmployeeDatas_summary_particularHold(payload_hd),
          );
        }
      }
    }
  };

  const GotoThePage = () => {
    const goPageNumber = Number(goPage);

    if (
      Math.ceil(
        state.EmployeeOfAdvanceAttendance_summaryRecordsCall.Total_Count == null
          ? 1
          : state.EmployeeOfAdvanceAttendance_summaryRecordsCall.Total_Count /
              10,
      ) >= goPageNumber ||
      goPageNumber == ""
    ) {
      setsno((goPageNumber - 1) * 10);

      GotoEnteredPage(goPageNumber);
    } else {
      toast.error("Invalid Page Number", {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        console.log(
          state.SideBarFiles.UserEmailID,
          "state.SideBarFiles.UserEmailID",
        );

        setempsearch(e);
      }, 500),
    [],
  );

  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    setsno(0);
    debouncedSearch(e.target.value);
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  return (
    <>
      <>
        <div
          style={{
            background: "#fff",
            display: "flex",
            width: "100%",
            flexDirection: "column",
            gap: "10px",
            padding: "19px",
            borderRadius: "8px",
            marginBottom: "30px",
          }}
        >
          <div className="AdvanceEmployeeListSearch">
            <span class="border-0  bg-transparent " id="search-addonAdvanca">
              <img src={SearchImg} width="100%" height="100%" />
            </span>
            <input type="text" placeholder="Search ..." onChange={tochange} />
          </div>
          <div
            className="NormalTableCalls"
            style={{
              height: "437px",
              overflowY: "auto",
              overflowX: "auto",
              width: "100%",
              background: "#fff",
              paddingRight: "12px",
            }}
          >
            <table
              className="TicketingTableOverviewsDashboard EmployeeTableOverviewsDashboard"
              style={{
                width: "100%",
                borderCollapse: "collapse",
                textAlign: "center",
                minWidth: "1000px",
              }}
            >
              <thead>
                <tr>
                  <th style={tableHeaderStyleFirst}>S.NO</th>{" "}
                  {/* Header for FilterName */}
                  <th style={tableHeaderStyle}>Date</th>
                  <th style={tableHeaderStyle}>Client Name</th>
                  <th style={tableHeaderStyle}>Punch In</th>
                  <th style={tableHeaderStyle}>Punch Out</th>
                  <th style={tableHeaderStyle}>Absent</th>
                  <th style={tableHeaderStyleLast}>Total</th>
                  {/* <th style={tableHeaderStyleLast}>Status</th> */}
                </tr>
              </thead>

              {state.EmployeeVerificationsNeed
                .advance_attendanceloader_summary ? (
                <>
                  <tbody className="tbodyReact">
                    <div
                      className="TableLoader"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        width: "100%", // Ensures it spans the full table width
                        transform: "translate(-50%, -50%)",
                      }}
                    >
                      <ShimmerTable
                        row={4}
                        col={9}
                        style={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%, -50%)",
                        }}
                      />
                    </div>
                  </tbody>
                </>
              ) : (
                <>
                  {dashboardData.length > 0 ? (
                    <tbody>
                      {dashboardData.map((item, index) => (
                        <tr
                          key={index}
                          style={{ borderBottom: "1px solid #ccc" }}
                        >
                          <td
                            style={tableCellStyle}
                            className="LabelNamesstate"
                          >
                            {Number(sno + index + 1)}
                          </td>
                          <td style={tableCellStyle}>
                            {" "}
                            {`${item?.date || "--"}`}
                          </td>
                          <td style={tableCellStyle}>
                            {item.client_id__client_name || "--"}
                          </td>
                          <td style={tableCellStyle}>
                            {item.punch_in_only || "--"}
                          </td>
                          <td style={tableCellStyle}>
                            {item.punch_in_out || "---"}
                          </td>
                          <td style={tableCellStyle}>{item.absent || "--"}</td>
                          <td style={tableCellStyle}>{item.total || "--"}</td>
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <tbody>
                      <tr key={0} style={{ borderBottom: "1px solid #ccc" }}>
                        <td colSpan="9" style={tableCellStyleno}>
                          {"No data Available"}
                        </td>
                      </tr>
                    </tbody>
                  )}{" "}
                </>
              )}
            </table>
          </div>
          {state.SideBarFiles.UserEmailID != "hdfcsales@uds.in" &&
          state.SideBarFiles.UserEmailID != "sbilife@uds.in" &&
          state.SideBarFiles.UserEmailID != "arcolab@uds.in" ? (
            <>
              {state.EmployeeOfAdvanceAttendance_summaryRecordsCall
                .Total_Count > 10 ? (
                <div
                  className="pagination"
                  style={{
                    justifyContent: "end",
                    width: "100%",
                    height: "30px",
                  }}
                >
                  <div
                    className=" pagination"
                    style={{ justifyContent: "end" }}
                  >
                    <div className="showrow1" style={{ padding: "4px" }}>
                      <button
                        className="btn btn prim"
                        style={{ border: "none" }}
                        onClick={() => {
                          handlePrevious(dtpageindex - 1);
                          setsno(sno - 10);
                        }}
                        disabled={dtpageindex == 1}
                      >
                        {"<"}
                      </button>
                      <span style={{ padding: "10px" }}>
                        <strong style={{ fontSize: "12px" }}>
                          {dtpageindex} of{" "}
                          {Math.ceil(
                            state.EmployeeOfAdvanceAttendance_summaryRecordsCall
                              .Total_Count == null
                              ? 1
                              : state
                                  .EmployeeOfAdvanceAttendance_summaryRecordsCall
                                  .Total_Count / 10,
                          )}{" "}
                        </strong>
                      </span>

                      <button
                        style={{ border: "none" }}
                        className="btn btn prim"
                        onClick={() => {
                          handleNext(dtpageindex);

                          setsno(sno + 10);
                        }}
                        disabled={
                          dtpageindex ==
                          Math.ceil(
                            state.EmployeeOfAdvanceAttendance_summaryRecordsCall
                              .Total_Count / 10,
                          )
                        }
                      >
                        {">"}
                      </button>

                      <span className="GOTOPageOuters">
                        <form
                          className="GotoPageForm"
                          onSubmit={(e) => e.preventDefault()}
                        >
                          <span className="GotoPageText">Go to Page</span>
                          <input
                            type="number"
                            value={goPage}
                            className="formcontrol_Table"
                            onChange={(e) => {
                              const value = e.target.value;
                              const newPageIndex = e.target.value;
                              if (!isNaN(newPageIndex)) {
                                if (newPageIndex != 0 && newPageIndex > 0) {
                                  setGoPage(newPageIndex);
                                } else if (
                                  newPageIndex == 0 ||
                                  newPageIndex < 0
                                ) {
                                  setGoPage("");
                                }
                              }
                            }}
                            step="1"
                            onKeyDown={(evt) => {
                              if (["e", "E", "+", "-", "."].includes(evt.key)) {
                                evt.preventDefault();
                              }
                            }}
                          />

                          <button
                            type="submit"
                            className="GOBTON btn"
                            disabled={goPage == ""}
                            onClick={(e) => {
                              GotoThePage();
                            }}
                          >
                            Go
                          </button>
                        </form>
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </>
          ) : (
            <>
              {state.EmployeeOfAdvanceAttendanceParticular_summaryRecordsCall
                .Total_Count > 10 ? (
                <div
                  className="pagination"
                  style={{
                    justifyContent: "end",
                    width: "100%",
                    height: "30px",
                  }}
                >
                  <div
                    className=" pagination"
                    style={{ justifyContent: "end" }}
                  >
                    <div className="showrow1" style={{ padding: "4px" }}>
                      <button
                        className="btn btn prim"
                        style={{ border: "none" }}
                        onClick={() => {
                          handlePrevious(dtpageindex - 1);
                          setsno(sno - 10);
                        }}
                        disabled={dtpageindex == 1}
                      >
                        {"<"}
                      </button>
                      <span style={{ padding: "10px" }}>
                        <strong style={{ fontSize: "12px" }}>
                          {dtpageindex} of{" "}
                          {Math.ceil(
                            state
                              .EmployeeOfAdvanceAttendanceParticular_summaryRecordsCall
                              .Total_Count == null
                              ? 1
                              : state
                                  .EmployeeOfAdvanceAttendanceParticular_summaryRecordsCall
                                  .Total_Count / 10,
                          )}{" "}
                        </strong>
                      </span>

                      <button
                        style={{ border: "none" }}
                        className="btn btn prim"
                        onClick={() => {
                          handleNext(dtpageindex);

                          setsno(sno + 10);
                        }}
                        disabled={
                          dtpageindex ==
                          Math.ceil(
                            state
                              .EmployeeOfAdvanceAttendanceParticular_summaryRecordsCall
                              .Total_Count / 10,
                          )
                        }
                      >
                        {">"}
                      </button>

                      <span className="GOTOPageOuters">
                        <form
                          className="GotoPageForm"
                          onSubmit={(e) => e.preventDefault()}
                        >
                          <span className="GotoPageText">Go to Page</span>
                          <input
                            type="number"
                            value={goPage}
                            className="formcontrol_Table"
                            onChange={(e) => {
                              const value = e.target.value;
                              const newPageIndex = e.target.value;
                              if (!isNaN(newPageIndex)) {
                                if (newPageIndex != 0 && newPageIndex > 0) {
                                  setGoPage(newPageIndex);
                                } else if (
                                  newPageIndex == 0 ||
                                  newPageIndex < 0
                                ) {
                                  setGoPage("");
                                }
                              }
                            }}
                            step="1"
                            onKeyDown={(evt) => {
                              if (["e", "E", "+", "-", "."].includes(evt.key)) {
                                evt.preventDefault();
                              }
                            }}
                          />

                          <button
                            type="submit"
                            className="GOBTON btn"
                            disabled={goPage == ""}
                            onClick={(e) => {
                              GotoThePage();
                            }}
                          >
                            Go
                          </button>
                        </form>
                      </span>
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </>
          )}
        </div>
      </>
    </>
  );
};
